/**
 * Regex to detect TikTok in-app browser
 * - tiktok: direct TikTok identifier
 * - ttwebview: TikTok WebView identifier
 * - bytedance: TikTok parent company
 * - musical[._]ly: TikTok's original app name (dot for iOS, underscore for Android)
 * - aweme: TikTok's internal codename
 * - bytelocale: present in Android TikTok UA strings
 */
const TIKTOK_AGENT_REGEX = /tiktok|ttwebview|bytedance|musical[._]ly|aweme|bytelocale/i;
/**
 * Checks if the current browser is TikTok's in-app browser
 * Works on both iOS and Android platforms
 */
export function isTikTokBrowser() {
    if (typeof navigator === 'undefined')
        return false;
    return TIKTOK_AGENT_REGEX.test(navigator.userAgent);
}
